import {BenchlingState} from 'redux-stores/reduceApp';
import {SampleGroup} from 'workflows/WorkflowConstants';

export class RequestSampleGroupsModelSelector {
  constructor(readonly state: BenchlingState) {}

  getSampleGroups(modelKey: string): Array<SampleGroup> | null {
    const {sampleGroupsById} = this.state.models.sampleGroups;
    const {sampleGroupIdsByRequestId} = this.state.models.requests.inputs;
    const requestSampleGroupIds = sampleGroupIdsByRequestId[modelKey] || null;
    if (requestSampleGroupIds == null) {
      return null;
    }
    const sampleGroups = requestSampleGroupIds.map((id: string) => sampleGroupsById[id]);
    if (sampleGroups.some((sampleGroup: SampleGroup) => sampleGroup == null)) {
      return null;
    }
    return sampleGroups;
  }
}
